import { Component, OnInit } from '@angular/core';
import { LoginObservableService } from "../../shared/loginObservable.service";

@Component({
  selector: 'app-connect',
  templateUrl: './connect.component.html',
  styleUrls: ['./connect.component.css']
})
export class ConnectComponent implements OnInit {

  connectsList = [{name:'John Doe',icon:'icon-Outgoing-call'},{name:'9858443516',icon:'icon-Incoming-call'},{name:'7722992584',icon:'icon-Miss-call'},{name:'8822662554',icon:'icon-Outgoing-call'}]

  constructor(private LoginObservableService: LoginObservableService) { }
  selectedConnectCategoryInd = 0;
  lastSelectedInd = 0;
  ngOnInit() {
  }


  selectedConnectCategory(ev){
    var temp;
    if(ev.index == 0){
      temp = 'Calls';
    }else if(ev.index == 1){
      temp = 'Chats';
    }else if(ev.index == 2){
      temp = 'Contact'
    }else if(ev.index == 3){
      temp = 'News_Board'
    }

    if(temp){
      var isFeatureAvailable = this.LoginObservableService.isThisFeatureIsAvailable(temp);
      if(isFeatureAvailable == 'false'){
      this.LoginObservableService.openSubscribenowPopup();
      this.selectedConnectCategoryInd = this.lastSelectedInd;
       return;
      }
    }

    this.selectedConnectCategoryInd = ev.index;
this.lastSelectedInd = ev.index;
  }
  

}



// WEBPACK FOOTER //
// ./src/app/shelf/connect/connect.component.ts